// extracted by mini-css-extract-plugin
export var alignCenter = "_b3-d";
export var bannerShown = "_b3-6";
export var buttonContent = "_b3-0";
export var cardList = "_b3-1";
export var centerContent = "_b3-2";
export var chevron = "_b3-3";
export var closePanelButton = "_b3-k";
export var conversationContextContainer = "_b3-l";
export var conversationDetailContainer = "_b3-4";
export var detailWrapper = "_b3-7";
export var dropdownButton = "_b3-e";
export var dropdownTitle = "_b3-9";
export var fullHeight = "_b3-5";
export var hidden = "_b3-a";
export var icon = "_b3-b";
export var mergeSuggestionWrapper = "_b3-m";
export var panel = "_b3-i";
export var portalButtonsWrapper = "_b3-c";
export var right = "_b3-j";
export var tableSummaryContainer = "_b3-8";
export var tableSummaryHeader = "_b3-g";
export var threeDotsButton = "_b3-f";
export var wide = "_b3-h";